export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const CLIENTS_LOADING = 'CLIENTS_LOADING';
export const CLIENTS_SUCCESS = 'CLIENTS_SUCCESS';
export const CLIENTS_FAIL = 'CLIENTS_FAIL';
export const PACKAGES_LOADING = 'PACKAGES_LOADING';
export const PACKAGES_SUCCESS = 'PACKAGES_SUCCESS';
export const PACKAGES_FAIL = 'PACKAGES_FAIL';
export const CREDITS_LOADING = 'CREDITS_LOADING';
export const CREDITS_SUCCESS = 'CREDITS_SUCCESS';
export const CREDITS_FAIL = 'CREDITS_FAIL';
export const ADD_CLIENT_INITIALIZE = 'ADD_CLIENT_INITIALIZE';
export const ADD_CLIENT_LOADING = 'ADD_CLIENT_LOADING';
export const ADD_CLIENT_SUCCESS = 'ADD_CLIENT_SUCCESS';
export const ADD_CLIENT_FAIL = 'ADD_CLIENT_FAIL';
export const GET_CLIENT_INITIALIZE = 'GET_CLIENT_INITIALIZE';
export const GET_CLIENT_LOADING = 'GET_CLIENT_LOADING';
export const GET_CLIENT_SUCCESS = 'GET_CLIENT_SUCCESS';
export const GET_CLIENT_FAIL = 'GET_CLIENT_FAIL';
export const SET_CURRENT_CLIENT = 'SET_CURRENT_CLIENT';
export const SAVE_CLIENT_INITIALIZE = 'SAVE_CLIENT_INITIALIZE';
export const SAVE_CLIENT_LOADING = 'SAVE_CLIENT_LOADING';
export const SAVE_CLIENT_SUCCESS = 'SAVE_CLIENT_SUCCESS';
export const SAVE_CLIENT_FAIL = 'SAVE_CLIENT_FAIL';
export const DELETE_CLIENT_INITIALIZE = 'DELETE_CLIENT_INITIALIZE';
export const DELETE_CLIENT_LOADING = 'DELETE_CLIENT_LOADING';
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
export const DELETE_CLIENT_FAIL = 'DELETE_CLIENT_FAIL';
export const RESELLERS_LOADING = 'RESELLERS_LOADING';
export const RESELLERS_SUCCESS = 'RESELLERS_SUCCESS';
export const RESELLERS_FAIL = 'RESELLERS_FAIL';
export const GET_RESELLER_INITIALIZE = 'GET_RESELLER_INITIALIZE';
export const GET_RESELLER_LOADING = 'GET_RESELLER_LOADING';
export const GET_RESELLER_SUCCESS = 'GET_RESELLER_SUCCESS';
export const GET_RESELLER_FAIL = 'GET_RESELLER_FAIL';
export const SET_CURRENT_RESELLER = 'SET_CURRENT_RESELLER';
export const ADD_RESELLER_INITIALIZE = 'ADD_RESELLER_INITIALIZE';
export const ADD_RESELLER_LOADING = 'ADD_RESELLER_LOADING';
export const ADD_RESELLER_SUCCESS = 'ADD_RESELLER_SUCCESS';
export const ADD_RESELLER_FAIL = 'ADD_RESELLER_FAIL';
export const SAVE_RESELLER_INITIALIZE = 'SAVE_RESELLER_INITIALIZE';
export const SAVE_RESELLER_LOADING = 'SAVE_RESELLER_LOADING';
export const SAVE_RESELLER_SUCCESS = 'SAVE_RESELLER_SUCCESS';
export const SAVE_RESELLER_FAIL = 'SAVE_RESELLER_FAIL';
export const DEALERS_LOADING = 'DEALERS_LOADING';
export const DEALERS_SUCCESS = 'DEALERS_SUCCESS';
export const DEALERS_FAIL = 'DEALERS_FAIL';
export const GET_DEALER_INITIALIZE = 'GET_DEALER_INITIALIZE';
export const GET_DEALER_LOADING = 'GET_DEALER_LOADING';
export const GET_DEALER_SUCCESS = 'GET_DEALER_SUCCESS';
export const GET_DEALER_FAIL = 'GET_DEALER_FAIL';
export const SET_CURRENT_DEALER = 'SET_CURRENT_DEALER';
export const ADD_DEALER_INITIALIZE = 'ADD_DEALER_INITIALIZE';
export const ADD_DEALER_LOADING = 'ADD_DEALER_LOADING';
export const ADD_DEALER_SUCCESS = 'ADD_DEALER_SUCCESS';
export const ADD_DEALER_FAIL = 'ADD_DEALER_FAIL';
export const SAVE_DEALER_INITIALIZE = 'SAVE_DEALER_INITIALIZE';
export const SAVE_DEALER_LOADING = 'SAVE_DEALER_LOADING';
export const SAVE_DEALER_SUCCESS = 'SAVE_DEALER_SUCCESS';
export const SAVE_DEALER_FAIL = 'SAVE_DEALER_FAIL';
export const SUPER_RESELLERS_LOADING = 'SUPER_RESELLERS_LOADING';
export const SUPER_RESELLERS_SUCCESS = 'SUPER_RESELLERS_SUCCESS';
export const SUPER_RESELLERS_FAIL = 'SUPER_RESELLERS_FAIL';
export const GET_SUPER_RESELLER_INITIALIZE = 'GET_SUPER_RESELLER_INITIALIZE';
export const GET_SUPER_RESELLER_LOADING = 'GET_SUPER_RESELLER_LOADING';
export const GET_SUPER_RESELLER_SUCCESS = 'GET_SUPER_RESELLER_SUCCESS';
export const GET_SUPER_RESELLER_FAIL = 'GET_SUPER_RESELLER_FAIL';
export const SET_CURRENT_SUPER_RESELLER = 'SET_CURRENT_SUPER_RESELLER';
export const ADD_SUPER_RESELLER_INITIALIZE = 'ADD_SUPER_RESELLER_INITIALIZE';
export const ADD_SUPER_RESELLER_LOADING = 'ADD_SUPER_RESELLER_LOADING';
export const ADD_SUPER_RESELLER_SUCCESS = 'ADD_SUPER_RESELLER_SUCCESS';
export const ADD_SUPER_RESELLER_FAIL = 'ADD_SUPER_RESELLER_FAIL';
export const SAVE_SUPER_RESELLER_INITIALIZE = 'SAVE_SUPER_RESELLER_INITIALIZE';
export const SAVE_SUPER_RESELLER_LOADING = 'SAVE_SUPER_RESELLER_LOADING';
export const SAVE_SUPER_RESELLER_SUCCESS = 'SAVE_SUPER_RESELLER_SUCCESS';
export const SAVE_SUPER_RESELLER_FAIL = 'SAVE_SUPER_RESELLER_FAIL';
export const GET_MESSAGE_LOADING = 'GET_MESSAGE_LOADING';
export const GET_MESSAGE_SUCCESS = 'GET_MESSAGE_SUCCESS';
export const GET_MESSAGE_FAIL = 'GET_MESSAGE_FAIL';
export const SAVE_MESSAGE_INITIALIZE = 'SAVE_MESSAGE_INITIALIZE';
export const SAVE_MESSAGE_LOADING = 'SAVE_MESSAGE_LOADING';
export const SAVE_MESSAGE_SUCCESS = 'SAVE_MESSAGE_SUCCESS';
export const SAVE_MESSAGE_FAIL = 'SAVE_MESSAGE_FAIL';
export const SNACKBAR_SUCCESS = 'SNACKBAR_SUCCESS';
export const SNACKBAR_CLEAR = 'SNACKBAR_CLEAR';
export const SNACKBAR_TYPE_ERROR = 'SNACKBAR_TYPE_ERROR';
export const SNACKBAR_TYPE_SUCCESS = 'SNACKBAR_TYPE_SUCCESS';
export const TRANSACTIONS_LOADING = 'TRANSACTIONS_LOADING';
export const TRANSACTIONS_FAIL = 'TRANSACTIONS_FAIL';
export const TRANSACTIONS_SUCCESS = 'TRANSACTIONS_SUCCESS';
export const RETRIEVE_CREDITS_LOADING = 'RETRIEVE_CREDITS_LOADING';
export const RETRIEVE_CREDITS_SUCCESS = 'RETRIEVE_CREDITS_SUCCESS';
export const RETRIEVE_CREDITS_FAIL = 'RETRIEVE_CREDITS_FAIL';
export const RETRIEVE_CREDITS_INITIALIZE = 'RETRIEVE_CREDITS_INITIALIZE';
export const RENEW_CREDITS_LOADING = 'RENEW_CREDITS_LOADING';
export const RENEW_CREDITS_SUCCESS = 'RENEW_CREDITS_SUCCESS';
export const RENEW_CREDITS_FAIL = 'RENEW_CREDITS_FAIL';
export const RENEW_CREDITS_INITIALIZE = 'RENEW_CREDITS_INITIALIZE';
export const SEARCH_SAVE = 'SEARCH_SAVE';
export const SEARCH_RESET = 'SEARCH_RESET';
export const GET_MAC_INITIALIZE = 'GET_MAC_INITIALIZE';
export const GET_MAC_LOADING = 'GET_MAC_LOADING';
export const GET_MAC_SUCCESS = 'GET_MAC_SUCCESS';
export const GET_MAC_FAIL = 'GET_MAC_FAIL';
export const PASSWORD_CHANGE_LOADING = 'PASSWORD_CHANGE_LOADING';
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS';
export const PASSWORD_CHANGE_FAIL = 'PASSWORD_CHANGE_FAIL';
export const PASSWORD_CHANGE_INITIALIZE = 'PASSWORD_CHANGE_INITIALIZE';
export const SEARCH_MAC_LOADING = 'SEARCH_MAC_LOADING';
export const SEARCH_MAC_SUCCESS = 'SEARCH_MAC_SUCCESS';
export const SEARCH_MAC_FAIL = 'SEARCH_MAC_FAIL';
export const SEARCH_MAC_INITIALIZE = 'SEARCH_MAC_INITIALIZE';
export const SUB_PACKAGES_LOADING = 'SUB_PACKAGES_LOADING';
export const SUB_PACKAGES_SUCCESS = 'SUB_PACKAGES_SUCCESS';
export const SUB_PACKAGES_FAIL = 'SUB_PACKAGES_FAIL';
export const COUNT_RESELLERS_LOADING = 'COUNT_RESELLERS_LOADING';
export const COUNT_RESELLERS_SUCCESS = 'COUNT_RESELLERS_SUCCESS';
export const COUNT_RESELLERS_FAIL = 'COUNT_RESELLERS_FAIL';
export const COUNT_DEALERS_LOADING = 'COUNT_DEALERS_LOADING';
export const COUNT_DEALERS_SUCCESS = 'COUNT_DEALERS_SUCCESS';
export const COUNT_DEALERS_FAIL = 'COUNT_DEALERS_FAIL';
export const COUNT_ALL_CLIENTS_LOADING = 'COUNT_ALL_CLIENTS_LOADING';
export const COUNT_ALL_CLIENTS_SUCCESS = 'COUNT_ALL_CLIENTS_SUCCESS';
export const COUNT_ALL_CLIENTS_FAIL = 'COUNT_ALL_CLIENTS_FAIL';
export const COUNT_ACTIVE_CLIENTS_LOADING = 'COUNT_ACTIVE_CLIENTS_LOADING';
export const COUNT_ACTIVE_CLIENTS_SUCCESS = 'COUNT_ACTIVE_CLIENTS_SUCCESS';
export const COUNT_ACTIVE_CLIENTS_FAIL = 'COUNT_ACTIVE_CLIENTS_FAIL';
export const COUNT_EXPIRED_CLIENTS_LOADING = 'COUNT_EXPIRED_CLIENTS_LOADING';
export const COUNT_EXPIRED_CLIENTS_SUCCESS = 'COUNT_EXPIRED_CLIENTS_SUCCESS';
export const COUNT_EXPIRED_CLIENTS_FAIL = 'COUNT_EXPIRED_CLIENTS_FAIL';
export const COUNT_TRIALS_LOADING = 'COUNT_TRIALS_LOADING';
export const COUNT_TRIALS_SUCCESS = 'COUNT_TRIALS_SUCCESS';
export const COUNT_TRIALS_FAIL = 'COUNT_TRIALS_FAIL';
export const COUNT_MINISTRA_LOADING = 'COUNT_MINISTRA_LOADING';
export const COUNT_MINISTRA_SUCCESS = 'COUNT_MINISTRA_SUCCESS';
export const COUNT_MINISTRA_FAIL = 'COUNT_MINISTRA_FAIL';
export const SEND_MESSAGE_INITIALIZE = 'SEND_MESSAGE_INITIALIZE';
export const SEND_MESSAGE_LOADING = 'SEND_MESSAGE_LOADING';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAIL = 'SEND_MESSAGE_FAIL';
export const ADD_TICKET_INITIALIZE = 'ADD_TICKET_INITIALIZE';
export const ADD_TICKET_LOADING = 'ADD_TICKET_LOADING';
export const ADD_TICKET_SUCCESS = 'ADD_TICKET_SUCCESS';
export const ADD_TICKET_FAIL = 'ADD_TICKET_FAIL';
export const TICKETS_LOADING = 'TICKETS_LOADING';
export const TICKETS_SUCCESS = 'TICKETS_SUCCESS';
export const TICKETS_FAIL = 'TICKETS_FAIL';
export const GET_TICKET_INITIALIZE = 'GET_TICKET_INITIALIZE';
export const GET_TICKET_LOADING = 'GET_TICKET_LOADING';
export const GET_TICKET_SUCCESS = 'GET_TICKET_SUCCESS';
export const GET_TICKET_FAIL = 'GET_TICKET_FAIL';
export const SET_CURRENT_TICKET = 'SET_CURRENT_TICKET';
export const SAVE_TICKET_INITIALIZE = 'SAVE_TICKET_INITIALIZE';
export const SAVE_TICKET_LOADING = 'SAVE_TICKET_LOADING';
export const SAVE_TICKET_SUCCESS = 'SAVE_TICKET_SUCCESS';
export const SAVE_TICKET_FAIL = 'SAVE_TICKET_FAIL';
export const TICKET_DETAILS_LOADING = 'TICKET_DETAILS_LOADING';
export const TICKET_DETAILS_FAIL = 'TICKET_DETAILS_FAIL';
export const TICKET_DETAILS_SUCCESS = 'TICKET_DETAILS_SUCCESS';
export const ADD_TICKET_DETAIL_INITIALIZE = 'ADD_TICKET_DETAIL_INITIALIZE';
export const ADD_TICKET_DETAIL_LOADING = 'ADD_TICKET_DETAIL_LOADING';
export const ADD_TICKET_DETAIL_SUCCESS = 'ADD_TICKET_DETAIL_SUCCESS';
export const ADD_TICKET_DETAIL_FAIL = 'ADD_TICKET_DETAIL_FAIL';
export const GET_ACTIVE_TICKETS_LOADING = 'GET_ACTIVE_TICKETS_LOADING';
export const GET_ACTIVE_TICKETS_SUCCESS = 'GET_ACTIVE_TICKETS_SUCCESS';
export const GET_ACTIVE_TICKETS_FAIL = 'GET_ACTIVE_TICKETS_FAIL';
export const TOTAL_STATS_CHART_LOADING = 'TOTAL_STATS_CHART_LOADING';
export const TOTAL_STATS_CHART_FAIL = 'TOTAL_STATS_CHART_FAIL';
export const TOTAL_STATS_CHART_SUCCESS = 'TOTAL_STATS_CHART_SUCCESS';
export const STATS_CHART_LOADING = 'STATS_CHART_LOADING';
export const STATS_CHART_FAIL = 'STATS_CHART_FAIL';
export const STATS_CHART_SUCCESS = 'STATS_CHART_SUCCESS';
export const SET_CURRENT_TARIFF = 'SET_CURRENT_TARIFF';
export const GET_CURRENT_TARIFF = 'GET_CURRENT_TARIFF';
export const RESET_CLIENT_INITIALIZE = 'RESET_CLIENT_INITIALIZE';
export const RESET_CLIENT_LOADING = 'RESET_CLIENT_LOADING';
export const RESET_CLIENT_SUCCESS = 'RESET_CLIENT_SUCCESS';
export const RESET_CLIENT_FAIL = 'RESET_CLIENT_FAIL';
//export const ADMIN_DELETE_CLIENT_INITIALIZE = 'DELETE_CLIENT_INITIALIZE';
//export const DELETE_CLIENT_LOADING = 'DELETE_CLIENT_LOADING';
//export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
//export const DELETE_CLIENT_FAIL = 'DELETE_CLIENT_FAIL';